export default "__VITE_ASSET__D4R5tu1j__"